import { createSelector } from 'reselect';
import { AB_KEY } from './constants';
import {
    SALP_PAGE_FOOTER,
    SALP_PAGE_SEO,
    SHOW_FACETED_SEARCHBAR,
    SHOW_REVIEW_COUNT,
    VARIANT_ON,
    WELL_GUIDE_HEADER_NAVIGATION,
    NEW_EXISTING_PROFILE_TOGGLE,
    VARIANT_SHOW_TOGGLE,
    TELEHEALTH_LINK_TO_PROFILE,
} from './experiments';
import { getThemeParameters } from '../theme';
import isZocdocBrand from '../../utils/isZocdocBrand';
import { useDropdownHeaderChevron } from '../../Home/experiments/insurancePickerUseDropdownHeaderChevron';

export const getABParameters = state => state[AB_KEY];

export const showFacetedSearchBar = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_FACETED_SEARCHBAR.experimentId] === VARIANT_ON &&
            isZocdocBrand(theme.directoryId);
    },
);

export const showReviewCount = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_REVIEW_COUNT.experimentId] === VARIANT_ON &&
            isZocdocBrand(theme.directoryId);
    },
);

export const showNewExistingToggle = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[NEW_EXISTING_PROFILE_TOGGLE.experimentId] === VARIANT_SHOW_TOGGLE &&
            isZocdocBrand(theme.directoryId);
    },
);

export const showSalpSeoContent = createSelector(
    [getABParameters],
    ab => ab[SALP_PAGE_SEO.experimentId] === VARIANT_ON,
);

export const showSalpSeoFooter = createSelector(
    [getABParameters],
    ab => ab[SALP_PAGE_FOOTER.experimentId] === VARIANT_ON,
);

export const showWellGuideLink = createSelector(
    [getABParameters],
    ab => ab[WELL_GUIDE_HEADER_NAVIGATION.experimentId] === VARIANT_ON,
);

export const useChevronDropdownHeader = createSelector(
    getABParameters,
    ab => useDropdownHeaderChevron(ab),
);

export const shouldLinkTelehealthProfile = createSelector(
    [getABParameters],
    ab => ab[TELEHEALTH_LINK_TO_PROFILE.experimentId] === VARIANT_ON,
);
